import { render, staticRenderFns } from "./ImageSelectTemplate.vue?vue&type=template&id=2423b4ec&scoped=true"
import script from "./ImageSelectTemplate.vue?vue&type=script&lang=js"
export * from "./ImageSelectTemplate.vue?vue&type=script&lang=js"
import style0 from "./ImageSelectTemplate.vue?vue&type=style&index=0&id=2423b4ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423b4ec",
  null
  
)

export default component.exports